import { cn } from '@tebuto/lib/utils'

interface HeadingProps {
    level: number
    children?: React.ReactNode
    className?: string
    trailing?: React.ReactNode
}

export default function Heading({
    level,
    children,
    className = '',
    trailing,
    ...rest
}: HeadingProps & React.HTMLAttributes<HTMLHeadingElement>) {
    const baseCss = cn('font-medium hyphens-auto md:leading-10 tracking-tight w-full text-foreground', className)

    const content = trailing ? (
        <span className="flex flex-wrap items-center gap-3">
            <span>{children}</span>
            {trailing}
        </span>
    ) : (
        children
    )

    switch (level) {
        case 1:
            return (
                <h1 className={cn('xl:text-4xl xs:text-3xl text-2xl', baseCss)} {...rest}>
                    {content}
                </h1>
            )
        case 2:
            return (
                <h2 className={cn('xl:text-3xl xs:text-2xl text-xl', baseCss)} {...rest}>
                    {content}
                </h2>
            )

        case 3:
            return (
                <h3 className={cn('xl:text-2xl xs:text-xl text-lg', baseCss)} {...rest}>
                    {content}
                </h3>
            )
        case 4:
            return (
                <h4 className={cn('xl:text-xl xs:text-lg text-base', baseCss)} {...rest}>
                    {content}
                </h4>
            )
        case 5:
            return (
                <h5 className={cn('xl:text-lg xs:text-base text-sm', baseCss)} {...rest}>
                    {content}
                </h5>
            )
    }
}
